module.exports = __webpack_public_path__ + "static/media/CTLI_15-111w.07751302.jpg";